import React 			from 'react';
import PropTypes 	from 'prop-types';
import BLComponent			from '../core/_BLComponent.jsx';


import {onEscapePress} 		from '../common/_Utilities.jsx';


export default class DynamicModal extends React.Component{
	constructor(props) {
		super(props);

		this.state = {
			defaultFooterClass:""
		}
	}

	componentDidMount() {
		if (this.props.data.closeOnEscape) onEscapePress(() => this.props.data.closeFunc());
	}

	componentDidUpdate() {
		if (this.props.data.closeOnEscape) onEscapePress(() => this.props.data.closeFunc());
	}

	render() {
		const {title, modalSize, ModalBody, ModalFooter, modal_allscreen = false, closeOutsideClicked = true} = this.props.data;	
		return (
			<div className="dynamic-modal">
				<div className="modal__overlay" onClick={closeOutsideClicked ? () => this.props.data.closeFunc() : null}></div>
				<div className={(modal_allscreen)?"dynamic-modal__content--allscreen dmodal__content":"modal__content dmodal__content"} onClick={closeOutsideClicked ? (e)=>this.checkClose(e):null}>
					<div className={"modal-body--" + modalSize + " l-relative"}>
						

						{this.renderModalHeader(title)}
						{this.renderModalBody(ModalBody)}

						{typeof ModalFooter != "undefined" && this.renderModalFooter(ModalFooter)}
					</div>
				</div>
			</div>
		);
	}

	renderModalHeader(title)
	{
		const {closeFunc} = this.props.data;
		return(
			<div className={"dynamic-modal__header" + (title.display?"-with-title bg-color--cloud":"")}>
				{title.display && 
					this.renderModalHeaderTitle(title)		
				}
				<div></div><div>{title.showClose && <i className="far fa-times modal__close" onClick={() => closeFunc()}></i> }</div>
			</div>
		)

	}

	renderModalHeaderTitle(title)
	{
		if (title.clickable)
		{
			return (
				<div className="modal__title l-cursor-pointer" onClick={()=>title.callback()}>
					{(title.showIcon)&&<i className={"l-margin-right " + title.iconClass} onClick={()=>title.clickIcon()} />}
					{title.name}
					
				</div>
			)
		}
		else
		{
			return (
				<div className="modal__title">
					{(title.showIcon)&&<i className={"l-cursor-pointer l-margin-right " + title.iconClass} onClick={()=>title.clickIcon()} />}
					{title.name}
				</div>
			)	
		}

	}

	renderModalBody(ModalBody)
	{
		return(

			<div className="modal__body">
				<ModalBody/>
			</div>
		)

	}

	renderModalFooter(ModalFooter)
	{
		const isRenderButtons = ( (typeof ModalFooter.buttons == "undefined") || (ModalFooter.buttons == null) || (ModalFooter.buttons == {}))?false:true;
		if ( (typeof ModalFooter.buttons.list == "undefined") || (ModalFooter.buttons.list.length == 0) )
			return null;
		else	
			return(
				<div className={(ModalFooter.footerClass==null)?this.state.defaultFooterClass:ModalFooter.footerClass}>
					{(isRenderButtons)&&this.renderButtons(ModalFooter.buttons)}
					{ModalFooter.dontshowagain&&this.renderDSA(ModalFooter.dontshowagain)}
				</div>
			)
	}

	renderButtons(buttons)
	{
		const buttonList = buttons.list;
		const buttonDir = buttons.direction.toLowerCase();
		const btnCode = buttonList.map((button, key) =>
				<div key={"btn-" + key} className="l-full-width l-pad-left--sm l-pad-right--sm l-pad-bottom--sm"><button className={"btn l-full-width " + button.class } onClick={()=>button.func()} disabled={button.disabled}>{button.name}</button></div>
			);
		return (
			<div className={ "l-flex " + ( (buttonDir == "row") ? "l-row": "l-column") + " button-group" }>
				{btnCode}
			</div>
		)
	}

	renderDSA(dsa)
	{

	}

	checkClose(e)
	{
		if(!$(e.target).hasClass("dmodal__content")) {
			return null;
		}
		else
		{
			this.props.data.closeFunc();
		}
	}
}

DynamicModal.propTypes = {
		data: PropTypes.shape( {
				title: PropTypes.shape( { name: PropTypes.string.isRequired, show: PropTypes.boolean, clickable: PropTypes.boolean, callback:PropTypes.func} ).isRequired
			,	modalSize: PropTypes.string
			,	closeOnEscape: PropTypes.boolean
			,	ModalBody: PropTypes.elementType.isRequired
			,	ModalFooter: PropTypes.shape( {
					buttons: PropTypes.shape( {
						direction: PropTypes.string
					,	list : PropTypes.arrayOf( PropTypes.shape( {name: PropTypes.string.isRequired, class: PropTypes.string, func:PropTypes.func.isRequired}) )
					} )
				,	dontshowagain: PropTypes.shape( {
						msg: PropTypes.string.isRequired
					,	display: PropTypes.boolean
					,	func: PropTypes.func.isRequired
					} )
				,	footerClass: PropTypes.string
				} )
			,	closeFunc: PropTypes.func.isRequired
		}).isRequired
	,	func: PropTypes.shape({
				
		})
}